import { memo, useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useMatchMedia } from '@/shared/lib/hooks/use-match-media.hook';
import { Text } from '@/shared/ui/text';

import * as Styled from './list-pagination.styles';
import { TanstackListPaginationProps } from './list-pagination.types';

const TanstackListPaginationComponent = ({
	pageSizeOptions = [25, 50, 100],
	pageSize,
	onPageSizeChange,
	className,
	total,
}: TanstackListPaginationProps) => {
	const { t } = useTranslation('common');
	const isMobile = useMatchMedia('mobile');

	const pageSizeSelectOptions = useMemo(
		() =>
			pageSizeOptions.map((size) => ({
				label: String(size),
				value: String(size),
			})),
		[pageSizeOptions],
	);

	if (!total) {
		return null;
	}

	return (
		<Styled.SelectWrapper className={className} gap={12} align="center" justify="flex-start" flexWrap="wrap">
			<Text size="m" label={isMobile ? t('pagination.rows') : t('pagination.rowsPerPage')} />
			<Styled.Select
				options={pageSizeSelectOptions}
				selected={String(pageSize)}
				onChange={(value) => onPageSizeChange?.(Number(value))}
			/>
		</Styled.SelectWrapper>
	);
};

export default memo(TanstackListPaginationComponent);
